import React from 'react';
import { Mail, Phone, Youtube, Instagram, Facebook, Linkedin } from 'lucide-react';
const LOGO_URL = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesigne%202024%2FMTDLarge%201.png&site=1856&w=191&h=108&user=1516&opt=w3';
export function Footer() {
  return <footer className="bg-brand-gray-900 border-t border-brand-gray-800 pt-16 pb-8" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-3">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-4">
            <a href="/" className="inline-block mb-6" data-id="element-5">
              <img src={LOGO_URL} alt="Medina Tactical Dynamics" className="h-16 w-auto" data-id="element-6" />
            </a>
            <p className="text-brand-gray-400 max-w-md mb-6 text-sm leading-relaxed" data-id="element-7">
              Committed to providing our clients with highest quality of service
              combined with a strong sense of 360° situational awareness.
            </p>
            <div className="flex space-x-4" data-id="element-8">
              <a href="https://www.youtube.com/channel/UCWe8nIgfZn-Lhny4k-Wn3Wg" target="_blank" rel="noreferrer" aria-label="YouTube" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-9">
                <Youtube className="w-5 h-5" data-id="element-10" />
              </a>
              <a href="https://www.instagram.com/medinatactical360/" target="_blank" rel="noreferrer" aria-label="Instagram" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-11">
                <Instagram className="w-5 h-5" data-id="element-12" />
              </a>
              <a href="https://www.facebook.com/TeamAPCUSA/" target="_blank" rel="noreferrer" aria-label="Facebook" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-13">
                <Facebook className="w-5 h-5" data-id="element-14" />
              </a>
              <a href="https://www.linkedin.com/in/jose-medina-a84845a/" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-15">
                <Linkedin className="w-5 h-5" data-id="element-16" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div data-id="element-17">
            <h3 className="text-xs font-bold text-brand-white uppercase tracking-widest mb-6" data-id="element-18">
              Navigation
            </h3>
            <ul className="space-y-3" data-id="element-19">
              <li data-id="element-20">
                <a href="/about-apc" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-21">
                  About Us
                </a>
              </li>
              <li data-id="element-22">
                <a href="/meet-the-founder" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-23">
                  Meet the Founder
                </a>
              </li>
              <li data-id="element-24">
                <a href="/crisis-management-planning" className="text-brand-teal hover:text-brand-teal-light transition-colors text-sm font-semibold" data-id="element-25">
                  Crisis Planning
                </a>
              </li>
              <li data-id="element-26">
                <a href="/law-enforcement-capabilities" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-27">
                  Law Enforcement
                </a>
              </li>
              <li data-id="element-28">
                <a href="/civilian-protection" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-29">
                  Civilian
                </a>
              </li>
              <li data-id="element-30">
                <a href="/corporate-critical-incidents-planning" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-31">
                  Corporate
                </a>
              </li>
              <li data-id="element-32">
                <a href="/training" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-33">
                  Training Calendar
                </a>
              </li>
              <li data-id="element-34">
                <a href="/strategic-partners" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-35">
                  Resources
                </a>
              </li>
              <li data-id="element-36">
                <a href="/blog" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-37">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-38">
            <h3 className="text-xs font-bold text-brand-white uppercase tracking-widest mb-6" data-id="element-39">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-40">
              <li data-id="element-41">
                <a href="tel:18666343373" className="flex items-center gap-3 text-brand-gray-400 hover:text-brand-teal transition-colors text-sm group" data-id="element-42">
                  <Phone className="w-4 h-4 text-brand-gray-600 group-hover:text-brand-teal flex-shrink-0" data-id="element-43" />
                  1-866-634-3373
                </a>
              </li>
              <li data-id="element-44">
                <a href="mailto:info@apc360zone.com" className="flex items-center gap-3 text-brand-gray-400 hover:text-brand-teal transition-colors text-sm group" data-id="element-45">
                  <Mail className="w-4 h-4 text-brand-gray-600 group-hover:text-brand-teal flex-shrink-0" data-id="element-46" />
                  info@apc360zone.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-47">
          <p className="text-brand-gray-500 text-xs" data-id="element-48">
            &copy; {new Date().getFullYear()} Medina Tactical Dynamics. All
            rights reserved.
          </p>
          <p className="text-brand-gray-600 text-xs" data-id="element-49">apc360zone.com</p>
        </div>
      </div>
    </footer>;
}